module.exports = __webpack_public_path__ + "img/tg.45aae08c.svg";